import { BaseModelActive } from "@core/base.model";
import { modulesDefault, UserModules } from "@core/constants/modules.contants";

export class UserModel extends BaseModelActive {
  superUser: boolean = false;
  name: string = "";
  email: string = "";
  cellphone: string = "";
  telephone: string = "";

  firebaseUids: string[] = [];

  modules: UserModules = modulesDefault;

  static build(dto: UserModel) {
    const entity = new UserModel(dto.id, dto.active, dto.createdAt, dto.updatedAt);
    entity.superUser = dto.superUser ?? false;
    entity.name = dto.name;
    entity.email = dto.email;
    entity.cellphone = dto.cellphone;
    entity.telephone = dto.telephone;
    entity.firebaseUids = dto.firebaseUids;
    entity.modules = { ...modulesDefault, ...dto.modules };
    return entity;
  }
}
